import React from 'react';
import { BrowserRouter, useRoutes, Outlet } from 'react-router-dom';

import Login from '@/page/Login';
import App from '@/page/App';
import Layout from '@/components/Layout';
import UserManagement from '@/page/System/UserManagement';
import RoleManagement from '@/page/System/RoleManagement';
import PermissionManagement from '@/page/System/PermissionManagement';
import SystemLog from '@/page/System/SystemLog';
import CustomerUserManagement from '@/page/User/UserManagement';
import CustomerUserRoleManagement from '@/page/User/UserRoleManagement';
import CustomerUserPermissionManagement from '@/page/User/UserPermissionManagement';
import LogDataManagement from '@/page/Data/LogDataManagement';
import LogDataDashboard from '@/page/Data/LogDataDashboard';
import CategoryManagement from '@/page/Cms/CategoryManagement';
import ProductManagement from '@/page/Cms/ProductManagement';
import ProductForm from '@/page/Cms/ProductManagement/ProductForm';
import NewsManagement from '@/page/Cms/NewsManagement';
import NewsForm from '@/page/Cms/NewsManagement/NewsForm';
import BannerManagement from '@/page/Cms/BannerManagement';
import SiteConfig from '@/page/Cms/SiteConfig';
import FaqManagement from '@/page/Cms/FaqManagement';
import ContactSubmissionList from '@/page/Cms/ContactSubmissionList';
import ChatManagement from '@/page/Cms/ChatManagement';
import ChatDetail from '@/page/Cms/ChatManagement/ChatDetail';
const renderLayOut = (Com: React.ComponentType) => {
  return (
    <Layout>
      <Com />
    </Layout>
  );
};

const GetRoutes = () => {
  const routes = useRoutes([
    {
      path: '/login',
      element: <Login />,
    },

    {
      path: '/system',
      element: renderLayOut(() => <Outlet />),
      children: [
        {
          path: 'manager',
          element: <UserManagement />,
        },
        {
          path: 'managerRole',
          element: <RoleManagement />,
        },
        {
          path: 'managerPermission',
          element: <PermissionManagement />,
        },
        {
          path: 'systemLog',
          element: <SystemLog />,
        },
      ],
    },
    {
      path: '/user',
      element: renderLayOut(() => <Outlet />),
      children: [
        {
          path: 'userList',
          element: <CustomerUserManagement />,
        },
        {
          path: 'userRole',
          element: <CustomerUserRoleManagement />,
        },
        {
          path: 'userPermission',
          element: <CustomerUserPermissionManagement />,
        },
      ],
    },
    {
      path: '/data',
      element: renderLayOut(() => <Outlet />),
      children: [
        {
          path: 'dataMark',
          element: <LogDataManagement />,
        },
        {
          path: 'dashboard',
          element: <LogDataDashboard />,
        },
      ],
    },
    {
      path: '/cms',
      element: renderLayOut(() => <Outlet />),
      children: [
        {
          path: 'category',
          element: <CategoryManagement />,
        },
        {
          path: 'product',
          element: <ProductManagement />,
        },
        {
          path: 'product/create',
          element: <ProductForm />,
        },
        {
          path: 'product/edit/:id',
          element: <ProductForm />,
        },
        {
          path: 'news',
          element: <NewsManagement />,
        },
        {
          path: 'news/create',
          element: <NewsForm />,
        },
        {
          path: 'news/edit/:id',
          element: <NewsForm />,
        },
        {
          path: 'banner',
          element: <BannerManagement />,
        },
        {
          path: 'siteConfig',
          element: <SiteConfig />,
        },
        {
          path: 'faq',
          element: <FaqManagement />,
        },
        {
          path: 'contactSubmission',
          element: <ContactSubmissionList />,
        },
        {
          path: 'chat',
          element: <ChatManagement />,
        },
        {
          path: 'chat/:sessionId',
          element: <ChatDetail />,
        },
      ],
    },
    {
      path: '/',
      element: renderLayOut(App),
    },
  ]);
  return routes;
};

const Router = () => {
  return (
    <BrowserRouter basename=''>
      <GetRoutes />
    </BrowserRouter>
  );
};

export default Router;
